import { Verify } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Verify');
      },
      class: 'w-[500px] h-[700px] rounded-[2px]',
    },
  },
};

export default Verify;
